'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { XIcon } from 'lucide-react';
import { Dialog as DialogPrimitive } from 'radix-ui';
import { cn } from '../../../lib/utils.js';
import { Button } from '../button.jsx';
function Dialog(_a) {
    var props = __rest(_a, []);
    return <DialogPrimitive.Root data-slot="dialog" {...props}/>;
}
function DialogTrigger(_a) {
    var props = __rest(_a, []);
    return <DialogPrimitive.Trigger data-slot="dialog-trigger" {...props}/>;
}
function DialogPortal(_a) {
    var props = __rest(_a, []);
    return <DialogPrimitive.Portal data-slot="dialog-portal" {...props}/>;
}
function DialogClose(_a) {
    var props = __rest(_a, []);
    return <DialogPrimitive.Close data-slot="dialog-close" {...props}/>;
}
function DialogOverlay(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<DialogPrimitive.Overlay data-slot="dialog-overlay" className={cn('data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0 fixed inset-0 z-50 bg-black/50', className)} {...props}/>);
}
function DialogContent(_a) {
    var className = _a.className, children = _a.children, _b = _a.showCloseButton, showCloseButton = _b === void 0 ? true : _b, props = __rest(_a, ["className", "children", "showCloseButton"]);
    return (<DialogPortal>
      <DialogOverlay />
      <DialogPrimitive.Content data-slot="dialog-content" className={cn('bg-popover text-popover-foreground ring-foreground/10 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl p-4 text-sm ring-1 duration-100 outline-none sm:max-w-sm', className)} {...props}>
        {children}
        {showCloseButton && (<DialogPrimitive.Close data-slot="dialog-close" asChild>
            <Button variant="ghost" className="absolute top-2 right-2" size="icon-sm">
              <XIcon />
              <span className="sr-only">Close</span>
            </Button>
          </DialogPrimitive.Close>)}
      </DialogPrimitive.Content>
    </DialogPortal>);
}
function DialogHeader(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<div data-slot="dialog-header" className={cn('flex flex-col gap-2', className)} {...props}/>);
}
function DialogFooter(_a) {
    var className = _a.className, _b = _a.showCloseButton, showCloseButton = _b === void 0 ? false : _b, children = _a.children, props = __rest(_a, ["className", "showCloseButton", "children"]);
    return (<div data-slot="dialog-footer" className={cn('bg-muted/50 -mx-4 -mb-4 flex flex-col-reverse gap-2 rounded-b-xl border-t p-4 sm:flex-row sm:justify-end', className)} {...props}>
      {children}
      {showCloseButton && (<DialogPrimitive.Close asChild>
          <Button variant="outline">Close</Button>
        </DialogPrimitive.Close>)}
    </div>);
}
function DialogTitle(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<DialogPrimitive.Title data-slot="dialog-title" className={cn('cn-font-heading text-base leading-none font-medium', className)} {...props}/>);
}
function DialogDescription(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<DialogPrimitive.Description data-slot="dialog-description" className={cn('text-muted-foreground *:[a]:hover:text-foreground text-sm *:[a]:underline *:[a]:underline-offset-3', className)} {...props}/>);
}
export { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger, };
